import { Component, Vue, Mixins } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import SBAPI from '@/util/SBAPI';
import { formSubmit, creditEdit } from '@/util/Form';
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';
import { UserPaymentMethodEnum, UserNgPaymentMethodEnum } from '@/generated/api';

@Component({
    components: AllComponents(),
})
export default class Complete extends Mixins(CommonView) {
    public display: boolean = false;

    public slug: string = "";
    public planId: number = 0;

    public error: string = "";
    public term1: boolean = false;

    public userPlan: SBAPI.UserPlan = {
        count: 1,
        plan: SBAPI.plan(),
        user: SBAPI.user(),
    }

    public paymentMethodOK: boolean = false;
    public paymentMethod: UserPaymentMethodEnum | null = UserPaymentMethodEnum.CARD;
    public ngPaymentMethod: UserNgPaymentMethodEnum | null = null;

    public async created() {
        await this.init();
        this.display = true;
    }

    public async init() {
        if (await this.isLoginRedirect(true)) return;
        this.slug = this.$route.params.slug;
        this.planId = Number(this.$route.params.planId);

        let userRes = await SBAPI.UserController.getUserUsingGET().catch(AxiosErrorHandler);
        if (isAxiosError(userRes)) {
            this.error = "" + userRes.data;
            return;
        }

        if (userRes.data.paymentMethod) {
            this.paymentMethodOK = true;
            this.paymentMethod = userRes.data.paymentMethod;
        }

        if (userRes.data.ngPaymentMethod) {
            this.ngPaymentMethod = userRes.data.ngPaymentMethod;
        }

        this.userPlan.user = userRes.data;

        let response = await SBAPI.PlanController.getPlanUsingGET(this.planId).catch(AxiosErrorHandler);
        if (isAxiosError(response)) {
            this.error = "" + response.data;
            return;
        }

        this.userPlan.plan = response.data;

        if (!this.userPlan.plan.currentOrder) {
            this.$router.push("/lineup/" + this.slug);
            return;
        }

        if (this.$route.query.count) {
            this.userPlan.count = Number(this.$route.query.count);
        }

        if (this.$route.query.err) {//戻るを押した場合、決済をやめるを押した場合
            return;
        }

        if (this.$route.query.token) {
            // 決済方法遷移戻り
            if (!this.$route.query.paymentMethod) {
                this.error = "リクエストが不正です。";
                return;
            }
            if (!this.loginStatus) {
                this.error = "リクエストが不正です。";
                return;
            }
            if (this.$route.query.token !== this.loginStatus.session) {
                this.error = "リクエストが不正です。";
                return;
            }
            if (Number(this.$route.query.currentOrderId) != this.userPlan.plan.currentOrder.id) {
                this.error = "申込み期間が終了しました。発送予定日をご確認の上、再度ご購入ください。";
                return;
            }
            await this.updateUserPaymentMethod(<UserPaymentMethodEnum>("" + this.$route.query.paymentMethod));
            await this.postUserPlan();
        }
    }

    public async nextButton() {
        if (!this.loginStatus) {
            this.error = "不正なリクエストです。";
            return;
        }
        if (!this.userPlan.plan.currentOrder) {
            return;
        }
        if (!this.term1 && this.userPlan.plan.period > 0) {
            this.error = "注意事項に同意してください。";
            return;
        }


        if (!this.loginStatus) {
            this.error = "不正なリクエストです。";
            return;
        }

        if (!this.paymentMethodOK && !this.paymentMethod) {
            this.error = "決済方法を選択してください。";
            return;
        }

        //決済方法登録済みならそのままPOST
        if (this.paymentMethodOK) {
            await this.postUserPlan();
            return;
        }

        //決済方法未登録
        //決済方法遷移
        if (this.paymentMethod === UserPaymentMethodEnum.CARD) {
            // カード遷移
            await this.card();
            return;
        } else if (this.paymentMethod === UserPaymentMethodEnum.GMOAB) {
            // 遷移しないで確定
            await this.updateUserPaymentMethod(this.paymentMethod);
            await this.postUserPlan();
            return;
        }

        throw "えらー";
    }

    public async card() {
        if (!this.loginStatus) {
            this.error = "不正なリクエストです。";
            return;
        }
        if (!this.userPlan.plan.currentOrder) {
            return;
        }
        let url = "/lineup/" + this.slug + "/plan/" + this.userPlan.plan.id + "/checkout?count=" + this.userPlan.count + "&currentOrderId=" + this.userPlan.plan.currentOrder.id + "&paymentMethod=" + this.paymentMethod + "&token=" + this.loginStatus.session;

        let redirectRes = await SBAPI.RedirectController.addRedirectUsingPOST({ url: url }).catch(AxiosErrorHandler);
        if (isAxiosError(redirectRes)) {
            this.error = "不正なリクエストです。";
            return;
        }
        try {
            let res = await creditEdit("1", "/api/credit/callBack?id=" + redirectRes.data.id, "/lineup/" + this.slug + "/plan/" + this.userPlan.plan.id + "/checkout?err=true&count=" + this.userPlan.count);
        } catch (error) {
            this.error = "" + error;
            return;
        }
    }

    public async updateUserPaymentMethod(paymentMethod: UserPaymentMethodEnum) {
        let response1 = await SBAPI.UserController.getUserUsingGET().catch(AxiosErrorHandler);
        if (isAxiosError(response1)) {
            this.error = "" + response1.data;
            throw "";
        }

        response1.data.paymentMethod = paymentMethod;

        let response2 = await SBAPI.UserController.putUserUsingPUT(response1.data).catch(AxiosErrorHandler);
        if (isAxiosError(response2)) {
            this.error = "" + response2.data;
            throw "";
        }
    }

    public async postUserPlan() {
        let response = await SBAPI.UserPlanController.postUserPlanUsingPOST(this.userPlan).catch(AxiosErrorHandler);
        if (isAxiosError(response)) {
            this.error = "" + response.data;
            return;
        }
        this.$router.push("/lineup/" + this.slug + "/plan/" + this.userPlan.plan.id + "/complete");
    }

}




